const GPRINTER_REASONS = {
    bluetooth_off: true,
    connection_lost: true,
    no_response: true,
    out_of_range: true,
    head_opened: true,
    cover_opened: true,
    out_of_paper: true
};

/**
 * Traducción del fallo de GPrinter. Cadena vacía si el error es de otra impresora.
 *
 * @param {object|null|undefined} error
 * @param {function} translate
 * @returns {string}
 */
function gprinterStatusText(error, translate) {
    if (!error || !GPRINTER_REASONS[error.reason] || typeof error.msg !== 'string') {
        return '';
    }
    return translate(error.msg, { s: error.code });
}

export { gprinterStatusText };
